// extracted by mini-css-extract-plugin
module.exports = {"link":"artist-module--link--17lyG","figure":"artist-module--figure--1CpR4","image":"artist-module--image--j7mcX","caption":"artist-module--caption--2Il4E"};